import { wait } from '@feedyou/utils'
import { BotId } from '@feedyou/schema'

import { FeedbotThunk } from '../types'
import { BotHeaderTab } from '../../features/botHeaderTabs/types'
import { appActions } from './appSlice'
import { isTabClosableSelector } from './selectors'
import { deployBotActions, possibleResumeHostingForBotIdSelector } from '../deployBot'
import { hostingVersionsApi } from '../../features/hostingVersions'
import * as actionTypes from '../../constants/actionTypes'
import { ServerApiTag } from '../serverApi'

export function selectTab(tab: BotHeaderTab, pendingScrollId?: string): FeedbotThunk {
  return (dispatch, getState) => {
    if (isTabClosableSelector(tab)(getState())) {
      dispatch(appActions.openNewTab({ tab }))
    }

    dispatch(appActions.selectTab({ tab, pendingScrollId }))
  }
}

export function setSelectedDashboardFilterTab(tabId: string) {
  return {
    type: actionTypes.SELECT_DASHBOARD_FILTER_TAB,
    payload: tabId,
    isRealtime: false
  }
}

export function checkDeployedVersion(botId?: BotId, timeout = 30000, retryCount = 8): FeedbotThunk {
  return async (dispatch, getState) => {
    if (!botId) {
      return
    }

    dispatch(hostingVersionsApi.util.invalidateTags([ServerApiTag.BOT_DEPLOYED_TREE(botId)]))

    const canRetryCheckForBotId = possibleResumeHostingForBotIdSelector(getState(), botId)
    const unsetRetryCheckForBotId = () =>
      dispatch(deployBotActions.unsetBotIdForPossibleResumeHosting(botId))

    try {
      await dispatch(hostingVersionsApi.endpoints.getHostingMetadata.initiate({ botId })).unwrap()

      canRetryCheckForBotId && unsetRetryCheckForBotId()
    } catch (error) {
      // @ts-ignore
      console.error('Deploy error', error)

      if (!canRetryCheckForBotId) {
        return
      }

      if (retryCount <= 0) {
        unsetRetryCheckForBotId()
        return
      }

      await wait(timeout)
        .then(() => {
          return dispatch(checkDeployedVersion(botId, timeout, retryCount - 1))
        })
        .catch(error => {
          console.error(error)
          return unsetRetryCheckForBotId()
        })
    }
  }
}
